"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagUG = function FlagUG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-77.27H-193v-37.67a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "45.73",
    width: "409.6",
    height: "44.73",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "44.73",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "135.18",
    width: "409.6",
    height: "44.73",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "179.91",
    width: "409.6",
    height: "44.73",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V101.63H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.17,12.18A42.37,42.37,0,1,1,11.8-30.19,42.37,42.37,0,0,1,54.17,12.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.35-13.62l4.18-1.67a1.15,1.15,0,0,0,.63-1.53c-.94-2.07-3.45-6.37-8.21-6.5A16,16,0,0,0,4.4-22.19a1.16,1.16,0,0,0-.56,1.65l2.52,4.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11-23.32l-1,0-.45,6.67,2.42,1.34L17.17-20A8.33,8.33,0,0,0,11-23.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.9,25.57,10,3.55a21.87,21.87,0,0,1,2.56-10,6.28,6.28,0,0,0,3.57-7.17,6.27,6.27,0,0,0-4.64-4.69,6.3,6.3,0,0,0-7.78,6.12,3.29,3.29,0,0,0,0,.44C-.29-10.67-1-9.36-1-9.36l5-1.32c.05.19.11.37.17.56L-.45-8.57l5-.61A6.39,6.39,0,0,0,6.9-6.74c-3.73,3-9.45,8.64-9.45,15,0,5.82,4.31,9.7,9.74,12.28a16.52,16.52,0,0,1,5.08,3.63l.06.05.47,7.23H2.17c-3.94,0-5,2.56-5,6.79L-1,35.59.59,38.54l.2-3.34,1.67,2.16s0-2.83,2.11-3.2A74.21,74.21,0,0,1,13,33.72l.7,10.78A29.18,29.18,0,0,0,4,46.6a24.36,24.36,0,0,1,5.41.29L8.8,48.76c4.43-2.41,12.54-2.46,12.54-2.46s-1.77-1.2-5.9-1.68l.09-10.9H22l1-2.55s-3.34-4.44-3.34-6.8a75.8,75.8,0,0,0,9.24,1.2ZM15.55,31.46l0-3.74,3.48,3.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.9,28.71c-1.57-6.29-8.46-8.22-15.72-12.58C5.31,11.41,10,3.55,10,3.55s26.34,7.73,28.31,18.87c1.53,8.67-4.72,14.15-7.87,15.72L31.6,35H25.76s6.19-4.82,6.29-9.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#696e7d"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.34,22.42C37,15,24.82,9.05,16.87,5.94c-2.54-.28-4.78,4,2.2,8.62,9.39,6.21,9.83,14.15,9.83,14.15l3.15-3.14C32,30.18,25.76,35,25.76,35H31.6l-1.12,3.14c3.14-1.57,9.39-7,7.86-15.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#fffcff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.34,22.42c-.88-4.94-6.53-9.19-12.56-12.41a18.27,18.27,0,0,0-5.43-.76c1.77,1.08,2.56,3.83,2.56,3.83-1.28-.78-4.13-.39-4.13-.39a10.28,10.28,0,0,1,2,3.13c7.69,6,8.08,12.89,8.08,12.89l3.15-3.14C32,30.18,25.76,35,25.76,35H31.6l-1.12,3.15c3.14-1.58,9.39-7,7.86-15.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.52-12.77a1,1,0,0,1-1,1,1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.72-8.77S2.43-6.08,3.94-5.3s3-1.44,3-1.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagUG;
exports["default"] = _default;